var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_337946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.25 0C9.70312 0 8.4375 1.26562 8.4375 2.8125V42.1875C8.4375 43.7344 9.70312 45 11.25 45H39.375C40.9219 45 42.1875 43.7344 42.1875 42.1875V11.25L30.9375 0H11.25Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.75 11.25H42.1875L30.9375 0V8.4375C30.9375 9.98438 32.2031 11.25 33.75 11.25Z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.1875 19.6875L33.75 11.25H42.1875V19.6875Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.5625 36.5625C36.5625 37.3359 35.9297 37.9688 35.1562 37.9688H4.21875C3.44531 37.9688 2.8125 37.3359 2.8125 36.5625V22.5C2.8125 21.7266 3.44531 21.0938 4.21875 21.0938H35.1562C35.9297 21.0938 36.5625 21.7266 36.5625 22.5V36.5625Z",
    fill: "#F15642"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.94238 26.6444C8.94238 26.2732 9.23488 25.8682 9.70598 25.8682H12.3033C13.7658 25.8682 15.0821 26.8469 15.0821 28.7228C15.0821 30.5003 13.7658 31.4904 12.3033 31.4904H10.426V32.9753C10.426 33.4704 10.111 33.7502 9.70598 33.7502C9.33473 33.7502 8.94238 33.4704 8.94238 32.9753V26.6444ZM10.426 27.2843V30.0855H12.3033C13.0571 30.0855 13.6533 29.4203 13.6533 28.7228C13.6533 27.9368 13.0571 27.2843 12.3033 27.2843H10.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.2843 33.7505C16.9131 33.7505 16.5081 33.548 16.5081 33.0544V26.6672C16.5081 26.2636 16.9131 25.9697 17.2843 25.9697H19.8591C24.9976 25.9697 24.8851 33.7505 19.9604 33.7505H17.2843ZM17.9931 27.3422V32.3794H19.8591C22.8952 32.3794 23.0302 27.3422 19.8591 27.3422H17.9931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M26.7075 27.4317V29.219H29.5749C29.9799 29.219 30.3849 29.624 30.3849 30.0164C30.3849 30.3876 29.9799 30.6914 29.5749 30.6914H26.7075V33.0525C26.7075 33.4462 26.4277 33.7486 26.0339 33.7486C25.5389 33.7486 25.2366 33.4462 25.2366 33.0525V26.6653C25.2366 26.2617 25.5403 25.9678 26.0339 25.9678H29.9813C30.4763 25.9678 30.7688 26.2617 30.7688 26.6653C30.7688 27.0253 30.4763 27.4303 29.9813 27.4303H26.7075V27.4317Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M35.1562 37.9688H8.4375V39.375H35.1562C35.9297 39.375 36.5625 38.7422 36.5625 37.9688V36.5625C36.5625 37.3359 35.9297 37.9688 35.1562 37.9688Z",
    fill: "#CAD1D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.4d365fa0a6c400fdeeb0884b0e21f5a3.svg";
export { ForwardRef as ReactComponent };